import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import DrawerRightIcon from '@atlaskit/icon/core/drawer-right';

import {
	PARENT_PRODUCTS,
	useConfluencePagePreviewPanel,
} from '@atlassian/confluence-page-preview-panel';
import { useIsPreviewPanelOpen } from '@atlassian/preview-panels-api';

import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';

export const PreviewPanelTestButton = () => {
	const previewPanelUrl = StatsigConfigurations.getString(
		'confluence_page_preview_panel_testing',
		'',
	);
	const title = `Preview Panel Test: ...${previewPanelUrl.substring(previewPanelUrl.length - 20)}`;

	const { openConfluencePagePreviewPanel, closeConfluencePagePreviewPanel } =
		useConfluencePagePreviewPanel(title, previewPanelUrl, PARENT_PRODUCTS.CONFLUENCE);
	const isOpen = useIsPreviewPanelOpen();

	if (!previewPanelUrl) {
		return null;
	}

	return (
		<IconButton
			icon={DrawerRightIcon}
			label="Preview Panel Test"
			onClick={() =>
				isOpen ? closeConfluencePagePreviewPanel() : openConfluencePagePreviewPanel()
			}
		/>
	);
};
